import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/gg-rank-topics', payload)
    return response.data.data.new_document || null
  },
  async getList(params) {
    let response = await api.get('/admin/gg-rank-topics', {
      params,
    })
    return response.data.data || null
  },
  async get(params) {
    let response = await api.get('/admin/gg-rank-topics/detail', {
      params,
    })
    return response.data.data.document || null
  },
  async update(payload) {
    let response = await api.put('/admin/gg-rank-topics', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/gg-rank-topics', {
      data: payload,
    })
    return response
  },
  async getAll(params) {
    let response = await api.get('/admin/gg-rank-topics/all', {
      params,
    })
    return response.data.data || null
  },
}
